import { useEffect, useState } from "react";

export const useScrollGnb = () => {
    const [isScrollDown, setIsScrollDown] = useState(false);
    let lastScroll = 0;

    useEffect(() => {
        const handleScroll = () => {
            const currentScroll = document.documentElement.scrollTop;

            if (currentScroll > lastScroll) {
                setIsScrollDown(true);
            } else if (currentScroll < lastScroll) {
                setIsScrollDown(false);
            } else if (currentScroll === 0) {
                setIsScrollDown(false);
            }

            lastScroll = currentScroll;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScroll]);

    return { isScrollDown };
};
